
/* OliveX — erstatter DC-runtimen fra produksjonsutkastet.
   Ansvar: reveal-animasjon, sticky kjoepslinje og kjoepswidget mot Shopify. */
(function () {
  "use strict";

  function reveal() {
    var io = new IntersectionObserver(function (entries) {
      document.documentElement.classList.add("js-reveal-ready");
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    document.querySelectorAll(".reveal, .chart").forEach(function (el) { io.observe(el); });
  }

  function sticky() {
    var bar = document.getElementById("sticky-buy");
    var hero = document.getElementById("topp");
    var buy = document.getElementById("bestill");
    if (!bar || !hero || !buy) return;
    var pastHero = false, atBuy = false;
    function update() { bar.classList.toggle("visible", pastHero && !atBuy); }
    new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; update(); }, { threshold: 0 }).observe(hero);
    new IntersectionObserver(function (en) { atBuy = en[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(buy);
  }

  function money(oere) {
    var v = oere / 100;
    return new Intl.NumberFormat("nb-NO", {
      minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2
    }).format(v) + " kr";
  }

  function readJson(selector, fallback) {
    var node = document.querySelector(selector);
    if (!node) return fallback;
    try { return JSON.parse(node.textContent); } catch (e) { return fallback; }
  }

  // Kampanjen skjules etter siste kampanjedag ogsaa naar siden ligger i
  // Shopifys mellomlager og Liquid-sjekken ikke har kjoert paa nytt.
  // Ugyldig datoformat regnes som utloept (sikker side).
  function campaignExpired(campaign) {
    if (!campaign || !campaign.endDate) return false;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(campaign.endDate)) return true;
    var d = new Date();
    var today = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
    return today > campaign.endDate;
  }

  function buyWidget() {
    var form = document.querySelector("[data-ox-buy-form]");
    if (!form) return;
    var planData = readJson("[data-ox-plans]", []) || [];
    var campaign = readJson("[data-ox-campaign]", null);
    if (campaignExpired(campaign)) {
      document.querySelectorAll("[data-ox-campaign-only]").forEach(function (el) { el.remove(); });
      campaign = null;
    }

    var qtyInput = form.querySelector("[data-ox-qty]");
    var planInput = form.querySelector("[data-ox-plan]");
    var returnInputs = form.querySelectorAll("[data-ox-campaign-return]");
    var consent = form.querySelector("[data-ox-campaign-consent]");
    var hint = form.querySelector("[data-ox-buy-hint]");
    var live = form.querySelector("[data-ox-buy-live]");
    var submit = form.querySelector("[data-ox-submit]");
    var choice = form.getAttribute("data-default-choice") || "none";
    if (!form.querySelector('[data-plan-choice="' + choice + '"]')) choice = "none";
    var qty = 1;
    var busy = false;
    var blocked = true;
    var lastMessage = "";

    function planById(id) {
      for (var i = 0; i < planData.length; i++) {
        if (String(planData[i].id) === String(id)) return planData[i];
      }
      return null;
    }

    function cardFor(value) {
      return form.querySelector('[data-plan-choice="' + value + '"]');
    }

    function selectedPill(card) {
      return card ? card.querySelector(".interval-pill.selected[data-plan-id]") : null;
    }

    function currentPlan() {
      if (choice !== "abo" && choice !== "kampanje") return null;
      var pill = selectedPill(cardFor(choice));
      return pill ? planById(pill.getAttribute("data-plan-id")) : null;
    }

    function months(pill) {
      var m = Number(pill && pill.getAttribute("data-months"));
      return m > 0 ? m : 1;
    }

    function renderCardTexts(card) {
      var pill = selectedPill(card);
      if (!pill) return;
      var m = months(pill);
      card.querySelectorAll("[data-ox-per-month]").forEach(function (el) {
        var price = Number(el.getAttribute("data-price")) || 0;
        var ship = Number(el.getAttribute("data-ship")) || 0;
        var free = Number(el.getAttribute("data-free")) || 0;
        var perDelivery = price + (ship && (!free || price < free) ? ship : 0);
        var amount = money(Math.round(perDelivery / m));
        var suffix = ship ? " per måned med frakt" : " per måned";
        el.textContent = m === 1 ? "Tilsvarer " + amount + suffix : "Tilsvarer " + amount + suffix + " (levering hver " + m + ". måned)";
      });
      if (campaign) {
        // Bindingen telles i flasker: med q flasker per levering trengs
        // ceil(min / q) leveranser. Frakt per levering faller bort over grensen.
        var deliveries = Math.ceil(campaign.min / qty);
        var bound = Math.min((deliveries - 1) * m, campaign.maxMonths);
        var firstValue = qty * campaign.sub - (campaign.sub - campaign.first);
        var laterValue = qty * campaign.sub;
        function shipFor(value) { return campaign.ship && (!campaign.free || value < campaign.free) ? campaign.ship : 0; }
        var goods = firstValue + (deliveries - 1) * laterValue;
        var freight = shipFor(firstValue) + (deliveries - 1) * shipFor(laterValue);
        card.querySelectorAll("[data-ox-binding-months]").forEach(function (el) {
          el.textContent = "med " + (qty === 1 ? "én flaske" : qty + " flasker") + " per levering er det "
            + deliveries + (deliveries === 1 ? " levering" : " leveranser") + " (ca. " + bound + " måneder)";
        });
        card.querySelectorAll("[data-ox-binding-total]").forEach(function (el) {
          el.textContent = "Totalt i bindingstiden: " + money(goods)
            + (campaign.ship ? " + frakt " + money(freight) + " = " + money(goods + freight) : " pluss frakt") + ".";
        });
      }
    }

    function announce(message) {
      if (message === lastMessage) return;
      lastMessage = message;
      if (live) live.textContent = message;
    }

    function render() {
      var heads = [];
      form.querySelectorAll(".plan-card").forEach(function (card) {
        var mine = card.getAttribute("data-plan-choice") === choice;
        card.classList.toggle("selected", mine);
        var head = card.querySelector(".plan-head");
        if (head) {
          head.setAttribute("aria-checked", mine ? "true" : "false");
          heads.push({ head: head, mine: mine });
        }
        renderCardTexts(card);
      });
      // Roving tabindex: ett tab-stopp for hele radiogruppen.
      var anyChecked = heads.some(function (h) { return h.mine; });
      heads.forEach(function (h, i) {
        h.head.setAttribute("tabindex", (h.mine || (!anyChecked && i === 0)) ? "0" : "-1");
      });
      form.querySelectorAll(".plan-when").forEach(function (box) {
        box.hidden = box.getAttribute("data-when") !== choice;
      });
      form.querySelectorAll(".qty-num").forEach(function (n) { n.textContent = String(qty); });
      form.querySelectorAll(".interval-pill").forEach(function (p) {
        p.setAttribute("aria-pressed", p.classList.contains("selected") ? "true" : "false");
      });
      qtyInput.value = String(qty);
      var plan = currentPlan();
      planInput.value = plan ? plan.id : "";
      var isCampaign = choice === "kampanje" && !!campaign;
      returnInputs.forEach(function (input) { input.disabled = !isCampaign; });

      var ready = choice === "bottle" || !!plan;
      var message = "";
      if (choice === "none") {
        message = "Velg et alternativ over.";
      } else if (!ready) {
        message = "Velg leveringsintervall.";
      } else if (isCampaign && consent && !consent.checked) {
        ready = false;
        message = "Kryss av for at du godtar bindingstiden for å fortsette.";
      }
      // aria-disabled i stedet for disabled: knappen blir i tab-rekkefoelgen,
      // og et klikk forklarer hva som mangler.
      blocked = !ready || busy;
      submit.setAttribute("aria-disabled", blocked ? "true" : "false");
      if (hint) hint.textContent = message;
    }

    function choose(value, focus) {
      var card = cardFor(value);
      if (!card) return;
      choice = value;
      render();
      if (focus) card.querySelector(".plan-head").focus();
    }

    function syncPills(planId) {
      form.querySelectorAll(".interval-pill[data-plan-id]").forEach(function (p) {
        p.classList.toggle("selected", p.getAttribute("data-plan-id") === String(planId));
      });
    }

    form.addEventListener("click", function (ev) {
      var step = ev.target.closest("[data-qty-step]");
      var pill = ev.target.closest(".interval-pill[data-plan-id]");
      var card = ev.target.closest("[data-plan-choice]");
      if (step) {
        ev.preventDefault();
        qty = Math.min(12, Math.max(1, qty + Number(step.getAttribute("data-qty-step"))));
        render(); return;
      }
      if (pill) {
        ev.preventDefault();
        syncPills(pill.getAttribute("data-plan-id"));
        if (card) choice = card.getAttribute("data-plan-choice");
        render(); return;
      }
      if (ev.target.closest("a, input, label")) {
        if (card && card.getAttribute("data-plan-choice") !== choice) choose(card.getAttribute("data-plan-choice"));
        return;
      }
      if (card) choose(card.getAttribute("data-plan-choice"));
    });

    form.addEventListener("keydown", function (ev) {
      var head = ev.target.closest(".plan-head[role=radio]");
      if (!head) return;
      var heads = Array.prototype.slice.call(form.querySelectorAll(".plan-head[role=radio]"));
      var index = heads.indexOf(head);
      var key = ev.key;
      if (key === " " || key === "Enter") {
        ev.preventDefault();
        choose(head.closest("[data-plan-choice]").getAttribute("data-plan-choice"));
      } else if (key === "ArrowDown" || key === "ArrowRight" || key === "ArrowUp" || key === "ArrowLeft") {
        ev.preventDefault();
        var dir = (key === "ArrowDown" || key === "ArrowRight") ? 1 : -1;
        var next = heads[(index + dir + heads.length) % heads.length];
        choose(next.closest("[data-plan-choice]").getAttribute("data-plan-choice"), true);
      }
    });

    if (consent) consent.addEventListener("change", render);

    form.addEventListener("submit", function (ev) {
      render();
      if (blocked) {
        ev.preventDefault();
        announce(hint ? hint.textContent : "");
        if (choice === "kampanje" && consent && !consent.checked) consent.focus();
        return;
      }
      busy = true;
      if (choice !== "kampanje" || !campaign) { render(); return; }
      // Kampanjen: legg varen i kurven og legg paa rabattkoden i samme kurv.
      // Feiler noe, sendes skjemaet vanlig med return_to=/discount/KODE.
      ev.preventDefault();
      var plan = currentPlan();
      var attributes = {};
      attributes["Kampanjevilkår"] = campaign.terms + " (" + new Date().toISOString() + ")";
      var added = false;
      var stopped = false;
      render();
      // Kampanjen gjelder ett abonnement per bestilling. Ligger det allerede et
      // abonnement i kurven, stopp her i stedet for aa slaa linjene sammen.
      fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (res) {
        return res.ok ? res.json() : { items: [] };
      }).then(function (cart) {
        var existing = (cart.items || []).filter(function (item) { return item.selling_plan_allocation; });
        if (existing.length) {
          stopped = true;
          var hasCampaign = existing.some(function (item) { return item.properties && item.properties._kampanje; });
          if (hasCampaign) { window.location.href = "/cart"; return null; }
          busy = false; render();
          var msg = "Du har allerede et abonnement i handlekurven. Fjern det i kurven først — kampanjen gjelder ett abonnement per bestilling.";
          if (hint) hint.textContent = msg;
          announce(msg);
          return null;
        }
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector("[name=id]").value), quantity: qty, selling_plan: plan.id, properties: { _kampanje: campaign.code } }] })
        });
      }).then(function (res) {
        if (stopped) return null;
        if (!res || !res.ok) throw new Error("add");
        added = true;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ discount: campaign.code, attributes: attributes })
        });
      }).then(function (res) {
        if (stopped) return;
        if (!res.ok) throw new Error("discount");
        window.location.href = "/cart";
      }).catch(function () {
        // Varen ligger allerede i kurven: bare legg paa koden. Ellers vanlig innsending.
        if (added) window.location.href = "/discount/" + encodeURIComponent(campaign.code) + "?redirect=%2Fcart";
        else form.submit();
      });
    });

    // Tilbake fra kurven (bfcache): nullstill «opptatt» slik at knappen virker igjen.
    window.addEventListener("pageshow", function (ev) {
      if (ev.persisted) { busy = false; render(); }
    });

    function selectCampaignFromLink() {
      if (!campaign) return;
      choose("kampanje");
      var target = document.getElementById("bestill");
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    document.addEventListener("click", function (ev) {
      var link = ev.target.closest("[data-ox-select-campaign]");
      if (!link) return;
      ev.preventDefault();
      selectCampaignFromLink();
      var head = cardFor("kampanje") && cardFor("kampanje").querySelector(".plan-head");
      if (head) head.focus({ preventScroll: true });
    });

    if (window.location.hash === "#kampanje") selectCampaignFromLink();

    render();
  }

  function init() { reveal(); sticky(); buyWidget(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else { init(); }
})();
